const getters = {
  mergedNews: state => state.data
}

export default getters



// WEBPACK FOOTER //
// ./src/store/modules/merged_news/getters.js